export default function(data) {
var __t, __p = '';
__p += '<div class="loading-container">\n  <div class="loading-icon">\n    <img src="' +
((__t = ( App.Assets.imagePath('loading-spinnger.gif') )) == null ? '' : __t) +
'" alt="loading spinner">\n  </div>\n</div>\n';
return __p
}